import axios from 'axios'
import { Api, AuthToken } from './consts'
export const GET_TRACKS = 'music/GET_TRACKS'
export const ADD_TRACK = 'music/ADD_TRACK'
export const TOGGLE_ADD_TRACK = 'music/TOGGLE_ADD_TRACK'
export const UPLOAD_TRACK = 'music/UPLOAD_TRACK'
export const TOGGLE_UPLOADING = 'music/TOGGLE_UPLOADING'
export const HANDLE_INPUT_CHANGE = 'music/HANDLE_INPUT_CHANGE'
export const DELETE_TRACK = 'music/DELETE_TRACK'
export const DELETE_TRACK_FILE = 'music/DELETE_TRACK_FILE'
export const REORDER_TRACKS = 'music/REORDER_TRACKS'
export const SHOW_ERROR = 'music/SHOW_ERROR'
export const RESET_TRACK = 'music/RESET_TRACK'
export const EDIT_TRACK = 'music/EDIT_TRACK'
export const UPDATE_TRACK = 'music/UPDATE_TRACK'

const initialState = {
    tracks: [],
    track: {},
    error: null,
    addTrackForm: false,
    uploading: false
}

export default ( state = initialState, action ) => {
    switch(action.type) {
        case GET_TRACKS:
            return {
                ...state,
                tracks: action.payload,
                error: null
            }
        case TOGGLE_ADD_TRACK:
            return {
                ...state,
                addTrackForm: !state.addTrackForm
            }
        case ADD_TRACK:
            return {
                ...state,
                tracks: [ ...state.tracks, action.payload ],
                addTrackForm: false,
                error: null
            }
        case UPLOAD_TRACK:
            return {
                ...state,
                track: {
                    ...state.track,
                    file: action.payload.file,
                    length: action.payload.length
                }
            }
        case TOGGLE_UPLOADING:
            return {
                ...state,
                uploading: !state.uploading
            }
        case HANDLE_INPUT_CHANGE:
            return {
                ...state,
                track: {
                    ...state.track,
                    [action.payload.name]: action.payload.value
                }
            }
        case DELETE_TRACK:
            return {
                ...state,
                tracks: state.tracks.filter(track => track._id !== action.payload.id)
            }
        case DELETE_TRACK_FILE:
            return {
                ...state,
                track: {
                    ...state.track,
                    file: null,
                    length: null
                }
            }
        case REORDER_TRACKS:
            return state
        case SHOW_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case RESET_TRACK:
            return {
                ...state,
                track: {}
            }
        case EDIT_TRACK:
            return {
                ...state,
                track: action.payload
            }
        case UPDATE_TRACK:
            return {
                ...state,
                track: {},
                tracks: state.tracks.map(track => {
                    if(track._id === action.payload._id) {
                        track = action.payload
                    }
                    return track
                })
            }
        default:
            return state
    }
}

const getTracks = tracks => (
    { type: GET_TRACKS, payload: tracks }
)

const toggleAddTrack = () => (
    { type: TOGGLE_ADD_TRACK }
)

const addTrack = track => (
    { type: ADD_TRACK, payload: track }
)

const uploadTrack = file => (
    { type: UPLOAD_TRACK, payload: file }
)

const toggleUploading = () => (
    { type: TOGGLE_UPLOADING }
)

const handeInputChange = change => (
    { type: HANDLE_INPUT_CHANGE, payload: change }
)

const deleteTrack = id => ( 
    { type: DELETE_TRACK, payload: { id } }
)

const deleteTrackFile = () => (
    { type: DELETE_TRACK_FILE }
)

const reorderTracks = () => ({
    type: REORDER_TRACKS
})

const showError = error => (
    { type: SHOW_ERROR, payload: error }
)

const resetTrack = () => ({
    type: RESET_TRACK
})

const editTrack = track => ({
    type: EDIT_TRACK,
    payload: track
})

const updateTrack = track => ({
    type: UPDATE_TRACK,
    payload: track
})

export const get_tracks = () => {
    return dispatch => {
        axios.get(`${Api}/tracks`)
        .then((response) => {
            dispatch(getTracks(response.data))
        })
        .catch((error) => {
            dispatch(showError(`No tracks were found.`))
        })
    }
}

export const toggle_add_track = () => {
    return dispatch => {
        dispatch(toggleAddTrack())
    }
}

export const add_track = track => {
    return dispatch => {
        axios.post(`${Api}/tracks/add`, track)
        .then((response) => {
            window.location.reload()
            dispatch(addTrack(response.data))
        })
        .catch((error) => {
            dispatch(showError(`Track couldn't be added, please try again.`))
        })
    }
}

export const delete_track = id => {
    return dispatch => {
        axios.post(`${Api}/tracks/delete`, {id})
        .then((response) => {
            dispatch(deleteTrack(id))
        })
        .catch((error) => {
            dispatch(showError(`Track couldn' be deleted, please try again.`))
        })
    }
}

export const upload_track = ({ target: { files } }) => {
    let data = new FormData()
    data.append('file', files[0])
    return dispatch => {
        dispatch(toggleUploading())
        axios.post(`${Api}/tracks/upload`, data)
        .then((response) => {
            dispatch(uploadTrack(response.data))
            dispatch(toggleUploading())
        })
        .catch((error) => {
            dispatch(toggleUploading())
            dispatch(showError(`File couldn't be uploaded, please try again.`))
        })
    }
}

export const handle_input_change = ({ target: { name,value } }) => {
    return dispatch => {
        dispatch(handeInputChange({name,value}))
    }
}

export const delete_track_file = file => {
    return dispatch => {
        axios.post(`${Api}/tracks/delete/file`, {file})
        dispatch(deleteTrackFile())
    }
}

export const reorder_tracks = tracks => {
    return dispatch => {
        axios.post(`${Api}/tracks/reorder`, tracks)
        dispatch(reorderTracks())
    }
}

export const reset_track = () => {
    return dispatch => {
        dispatch(resetTrack())
    }
}

export const edit_track = track => {
    return dispatch => {
        dispatch(editTrack(track))
    }
}

export const update_track = track => {
    return dispatch => {
        axios.post(`${Api}/tracks/update`, track)
            .then((response) => {
                dispatch(updateTrack(track))
            })
            .catch((error) => {
                console.log(`error`)
            })
    }
}


// WEBPACK FOOTER //
// ./src/modules/music.js